module.exports = __webpack_public_path__ + "img/logo-centered.f7588355.jpg";